"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _themeUi = require("theme-ui");

var React = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/** @jsx jsx */
var TextInput = React.forwardRef(function (_a, ref) {
  var sx = _a.sx,
      _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      props = (0, _tslib.__rest)(_a, ["sx", "variant"]);
  return (0, _themeUi.jsx)(_themeUi.Input, (0, _tslib.__assign)({
    as: "input",
    ref: ref,
    sx: (0, _tslib.__assign)((0, _tslib.__assign)({
      ':focus': {
        outline: 'none',
        borderColor: 'primary'
      }
    }, sx), {
      variant: "forms." + variant + ".input"
    })
  }, props));
});
TextInput.displayName = 'TextInput';
TextInput.defaultProps = {
  type: 'text'
};
var _default = TextInput;
exports.default = _default;